import styled from 'styled-components';
type InputProps = {
  color?: string;
  size?: string;
  marginLeft?: string;
};
export const Root = styled.div<InputProps>`
  display: inline-block;
  flex-direction: column;
  vertical-align: text-top;
  background-color: ${({ theme }) => theme.colors.surface};
  width: ${({ size }) => (size ? size : '100%')};
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 24px;
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};

  h3 {
    color: ${({ theme }) => theme.colors.grey5};
    margin-top: 0;
    font-size: 18px;
  }
`;
